/*
  taroni-strip.js
  Motion for sections/taroni-strip.liquid.
  - Default (data-pin="false"): native horizontal scroll everywhere, arrows scroll the list.
  - With data-pin="true", desktop with GSAP: pin the section, move the strip sideways with the scroll
    (scrub: it follows the reader's speed and goes back on scroll up). The arrows
    scroll the page to the next / previous image, the bar shows the position.
  - Phone, prefers-reduced-motion, theme editor or no GSAP: native horizontal
    scroll (swipe, trackpad, keyboard on the focused list); arrows scroll the list.
  GSAP is usually already on the page (loaded by taroni-story); if not, it is
  loaded here from cdnjs before starting the pinned mode.
*/
(function () {
  var GSAP = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve(true);
    var p = window.gsap ? Promise.resolve() : loadScript(GSAP);
    return p.then(function () { return window.ScrollTrigger ? null : loadScript(ST); })
      .then(function () { return !!(window.gsap && window.ScrollTrigger); })
      .catch(function () { return false; });
  }

  function setup(root) {
    if (root.dataset.tgReady) return;
    root.dataset.tgReady = '1';

    var list = root.querySelector('.tg__list');
    var items = Array.prototype.slice.call(root.querySelectorAll('.tg__item'));
    var bar = root.querySelector('.tg__bar');
    var prev = root.querySelector('.tg__arrow[data-dir="-1"]');
    var next = root.querySelector('.tg__arrow[data-dir="1"]');
    var pinned = null; /* the ScrollTrigger while pinned, null in native mode */

    function paint(progress) {
      var vis = Math.min(1, list.clientWidth / Math.max(list.scrollWidth, 1));
      if (pinned) vis = Math.min(1, root.clientWidth / Math.max(list.scrollWidth, 1));
      bar.style.width = (vis * 100) + '%';
      bar.style.transform = 'translateX(' + (progress * ((1 - vis) / vis) * 100) + '%)';
      if (prev) prev.disabled = progress <= 0.001;
      if (next) next.disabled = progress >= 0.999;
    }

    function nativeProgress() {
      var max = list.scrollWidth - list.clientWidth;
      return max > 0 ? list.scrollLeft / max : 0;
    }

    list.addEventListener('scroll', function () { if (!pinned) paint(nativeProgress()); }, { passive: true });
    window.addEventListener('resize', function () { if (!pinned) paint(nativeProgress()); });
    items.forEach(function (it) {
      var im = it.querySelector('img');
      if (im && !im.complete) im.addEventListener('load', function () {
        if (pinned) window.ScrollTrigger.refresh(); else paint(nativeProgress());
      }, { once: true });
    });

    function step(dir) {
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!pinned) {
        var w = items[0] ? items[0].offsetWidth + 4 : list.clientWidth * 0.8;
        list.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      /* pinned: find the next image edge after the current offset, scroll the page there */
      var dist = list.scrollWidth - root.clientWidth;
      var x = pinned.progress * dist;
      var target = x;
      if (dir > 0) {
        for (var i = 0; i < items.length; i++) { if (items[i].offsetLeft > x + Math.max(8, items[i].offsetWidth * 0.4)) { target = items[i].offsetLeft; break; } }
        if (target === x) target = dist;
      } else {
        target = 0;
        for (var j = items.length - 1; j >= 0; j--) { if (items[j].offsetLeft < x - Math.max(8, items[j].offsetWidth * 0.4)) { target = items[j].offsetLeft; break; } }
      }
      var p = Math.max(0, Math.min(1, target / dist));
      window.scrollTo({ top: pinned.start + p * (pinned.end - pinned.start), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    paint(0);

    var skip = root.dataset.pin !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode);
    if (skip) return;

    ensureGsap().then(function (ok) {
      if (!ok) return;
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.config({ ignoreMobileResize: true });
      var top = function () {
        var probe = document.createElement('div');
        probe.style.cssText = 'position:absolute;visibility:hidden;height:var(--tg-top)';
        root.appendChild(probe); var h = probe.offsetHeight; root.removeChild(probe);
        return h || 0;
      };
      gsap.matchMedia().add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', function () {
        root.classList.add('is-pinned');
        var dist = function () { return Math.max(0, list.scrollWidth - root.clientWidth); };
        var tween = gsap.to(list, {
          x: function () { return -dist(); },
          ease: 'none',
          scrollTrigger: {
            trigger: root,
            start: function () { return 'top top+=' + top(); },
            end: function () { return '+=' + Math.round(dist() * 0.6); }, /* the strip moves a bit faster than the scroll, as in the approved demo */
            pin: true,
            scrub: 0.6,
            invalidateOnRefresh: true,
            onUpdate: function (st) { paint(st.progress); },
            onRefresh: function (st) { paint(st.progress); }
          }
        });
        pinned = tween.scrollTrigger;
        return function () {
          pinned = null;
          root.classList.remove('is-pinned');
          gsap.set(list, { clearProps: 'x' });
          paint(nativeProgress());
        };
      });
    });
  }

  function init() { document.querySelectorAll('[data-taroni-strip]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
